import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=0a6a3dec&"
import script from "./Collapse.vue?vue&type=script&setup=true&lang=js&"
export * from "./Collapse.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports